import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["wrappedComponentRef"];
import RouterContext from './RouterContext';
import hoistStatics from 'hoist-non-react-statics';
import invariant from '../tiny-invariant';

// Omit taken from https://github.com/Microsoft/TypeScript/issues/28339#issuecomment-467220238
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A public higher-order component to access the imperative API
 */
function withRouter(Component) {
  const displayName = `withRouter(${Component.displayName || Component.name})`;
  const C = props => {
    // @ts-ignore wrappedComponentRef exists on WithRouterProps but TS can't narrow the union after rest
    const {
        wrappedComponentRef
      } = props,
      remainingProps = _objectWithoutPropertiesLoose(props, _excluded);
    return /*#__PURE__*/_jsx(RouterContext.Consumer, {
      children: context => {
        invariant(context, `You should not use <${displayName} /> outside a <Router>`);
        return (
          /*#__PURE__*/
          // @ts-ignore remainingProps + context doesn't satisfy P — generic plumbing is unsound
          _jsx(Component, Object.assign({}, remainingProps, context, {
            ref: wrappedComponentRef
          }))
        );
      }
    });
  };
  C.displayName = displayName;
  C.WrappedComponent = Component;

  // @ts-ignore hoistStatics return type doesn't match the withRouter generic signature
  return hoistStatics(C, Component);
}
export default withRouter;